// Module
var code = "<script id=\"wcc-components-wcc-video-picker\" type=\"text/template\">\r\n    <media-picker-dialog params=\"model: mediaPickerConfig\"></media-picker-dialog>\r\n</script>";
// Exports
module.exports = code;